module.exports = __webpack_public_path__ + "img/ORDER-ABC.02b0d248.png";